import O from "./O";
import Structure from "./Structure";
import ChannelDropdown from './ChannelDropdown';
import Id from './IdFactory';
import DeleteIcon from '@material-ui/icons/Delete';

function ChannelRow({template,channelId, channel,onEvent,
  templateDispatch,
}){


  let structure = template.compact.channelGroupStructure;

  let { channelGroups } = template.compact;
  let placements = Object.keys(channelGroups).filter(groupId => {
    return channelGroups[groupId].includes(channelId);
  })

  return (
    <tr class="hoverable-parent">
      <td><ChannelDropdown onChange={color => {
        onEvent({
          ...channel,
          color:color[0]
        })
      }} 
      value={[channel.color]} /></td>
      <td><input onChange={(e) => {
        let val = e.target.value;
        debugger;
        onEvent({ ...channel, label:val });
      }} 
      value={channel.label}
      placeholder={"Channel " + channel.defaultValue}/></td>

      <td style={{
        //border:'1px solid blue',
        padding:20,
        textAlign:'center',
        position:'relative',
      }}><div class="sg-row v-center h-center"> <Structure {...{
        interactive:true,
        structure,
        onChange:templateDispatch,
        placements,
        template,
        channelId,
      }}/>
      </div>
      </td>

      
      <td>
        <div class="visible-on-parent-hover" onClick={() => {


          let newChannelGroups = Object.fromEntries(Object.entries(
            channelGroups
          ).map(([key,list]) => {
            return [key,list.filter(x => x!==channelId)]
          }))

          let newChannels = { ...template.compact.channels };
          delete newChannels[channelId];

          templateDispatch({
            channels:newChannels,
            channelGroups:newChannelGroups
          })


          
        }}>
        <DeleteIcon/>
        </div>
      </td>

    </tr>
  )

}


function Channel(channels){
  return { color:"none", label:"", channelsUsed:[] }
}

export default function ChannelConfig({
  template,
  templateDispatch,
  addChannel=() => {},
}){


  let { 
    channels, 
    channelGroupStructure 
  } = template.compact;

  


  let usedColors = Object.values(channels).map(x => x.color);

  const headings = ["Color","Channel","Placement"];

  return (
    <div>
      {false && <div> {JSON.stringify(channels)} </div>}

      <h4>Channels</h4>

      <table style={{marginTop:20}}>
        <tr>
          {headings.map(val => <td style={{fontSize:18}}>{val}</td>)}
          
          <td><button onClick={() => {

            let color = ["red","green","blue"].find(color => !usedColors.includes(color)) || "none";

            let allExistingDefaults = Object.values(channels).map(x => x.defaultValue)
            let maxExistingDefault = Math.max(0,...allExistingDefaults)
            let defaultValue = (1+maxExistingDefault)

            templateDispatch({ channels:{
              ...channels,
              [Id()]:{ color, label:"", defaultValue },
            }})
          }}>Add</button></td>

        </tr>

        {Object.entries(channels).map(([channelId,channel]) => {
          return channel && <ChannelRow {...{
            template,
            templateDispatch,
            channelId,
            channel
          }} _id={channelId} onEvent={(newValue) => {

            let newChannels;
            if(!newValue){
              newChannels = { ...channels };
              delete newChannels[channelId];
            }else{
              newChannels = {
                ...channels,
                [channelId]:{
                  ...channel,
                  ...newValue
                }
              }
            }
            templateDispatch({channels:newChannels})
          }}/>
        })}



      </table>

    </div>
  )




}
